import api from './index';
import userApi from './user';
//
import { CtrlParamCodes } from '../app.const';
//
let exports = {};

let getMerchantCtrlParamValueSyncExt = function ({merchantId = null, merchantType = null, paramCode}) {
    //
    let theVipLevel = null;
    //
    let postData = {};
    postData.code = paramCode;
    postData.merchantId = merchantId;
    postData.merchantType = merchantType;
    exports.getMerchantCtrlParamValueSync(postData, function (result) {
        if(result.type == 'info') {
            theVipLevel = result.data;
        }
    });
    return theVipLevel;
};

exports.checkCtxMerchantVipLevel = function (paramCode, featureName = null) {
    //（根据上下文用户信息获取）当前商户的vip级别
    let ctxVipLevel = userApi.getScopeEntityVipLevel();
    //获取指定特性控制参数vip级别
    let theVipLevel = getMerchantCtrlParamValueSyncExt({paramCode});
    //
    if(theVipLevel == null || ctxVipLevel >= theVipLevel) {
        return null;
    } else {
        let vipLevel = getEnumMap('vipLevel', 'value2text');
        let vipLevelName = vipLevel[theVipLevel] || ''; //（根据枚举获取）vip级别名称
        return (featureName == null ? '此功能' : featureName) + '受限（所需vip级别为【' + vipLevelName + '】）'
    }
};

exports.checkVipLevelForAddCom = function (comLevel) {
    let paramCode = CtrlParamCodes['VIP_VALVE_FOR_ORG_LEVEL_' + comLevel];
    //
    let featureName = '添加' + comLevel + '级公司';
    //
    return exports.checkCtxMerchantVipLevel(paramCode, featureName);
};

// 控制参数
exports.getMerchantCtrlParamValue = function (data, callback) {// 根据code获取控制参数值
    api.post('/merchtComn/merchant/ctrl/param/value/get')
    .data(data)
    .done(callback)
    .go();
};

// 业务参数
exports.getMerchantBizParamValue = function (data, callback) {// 根据code获取控制参数值
    api.post('/merchtComn/merchant/biz/param/value/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getMerchantCtrlParamValueSync = function (data, callback) {// 根据code获取控制参数值
    api.post('/merchtComn/merchant/ctrl/param/value/get')
    .sync(true)
    .data(data)
    .done(callback)
    .go();
};

//
exports.getQualiType = function (data, callback) {// 根据资质类型id查询资质类型
    api.get('/merchtComn/quali/type/get')
    .params(data)
    .done(callback)
    .go();
};

exports.getQualiTypeByCode = function (data, callback) {// 根据资质类型code查询资质类型
    api.get('/merchtComn/quali/type/get/by/code')
    .params(data)
    .done(callback)
    .go();
};

exports.getQualiTypeListByMerchantType = function (params, callback) {// 根据不同商户类型查看不同的资质类型列表
    api.get('/merchtComn/quali/type/list/get/by/merchantType')
    .params(params)
    .done(callback)
    .go();
};

exports.getQualiTypeListByCode = function (data, callback) {// 获取资质类型列表（根据不同的code查看不同的资质类型）
    api.post('/merchtComn/quali/type/list/get/by/code')
    .data(data)
    .done(callback)
    .go();
};

//===================商户业务关系======================
exports.getMerchantBizRelListUnbackedToDelete = function (params, callback) {// 根据商户类型获取商户业务关系分页列表
    api.post('/merchtComn/merchant/biz/rel/list/get/unbacked')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getMerchantBizRelList = function (params, callback) {// 获取商户业务关系列表
    api.post('/merchtComn/merchant/biz/rel/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getMerchantBizRel = function (params, callback) {// 根据id查询商户业务关系
    api.post('/merchtComn/merchant/biz/rel/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.saveMerchantBizRel = function (params, callback) {// 保存商户业务关系
    api.post('/merchtComn/merchant/biz/rel/save/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.doSaveMerchantBizRel = function (params, callback) {// 单条保存商户业务关系
    api.post('/merchtComn/merchant/biz/rel/save/do/single')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.updateMerchantBizRel = function (params, callback) {// 更新商户业务关系信息
    api.post('/merchtComn/merchant/biz/rel/update/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.deleteMerchantBizRel = function (params, callback) {// 刪除商户业务
    api.post('/merchtComn/merchant/biz/rel/delete/do')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.saveMerchantBizRelSinge = function (params, callback) {// 保存商户业务关系
    api.post('/merchtComn/merchant/biz/rel/singe/save/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

/** 获取当前商户的给定商户类型的（存在于给定的关系商户id列表中的）关系商户id子集 */
exports.getMerchantBizRelPeerMerchantIds = function (data, callback) {// 获取当前商户的给定商户类型的（存在于给定的关系商户id列表中的）关系商户ids
    api.post('/merchtComn/merchant/biz/rel/peerMerchantIds/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
/** 获取当前商户的给定商户类型的（存在于给定的关系商户id列表中的）关系商户id子集 */
exports.getMerchantBizRelPeerMerchantIdsByContextAndPeerMerchantType = function (data, callback) {// 获取当前商户的给定商户类型的（存在于给定的关系商户id列表中的）关系商户ids
    api.post('/merchtComn/merchant/biz/rel/peerMerchantIds/get/by/context/and/peerMerchantType')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

/** 获取当前商户的给定商户类型的（存在于给定的关系商户id列表中的）关系商户id子集 */
exports.getMerchantBizRelPeerMerchantIdsByContextAndPeerMerchantTypeAndUnBlock = function (data, callback) {// 获取当前商户的给定商户类型的（存在于给定的关系商户id列表中的）关系商户ids
    api.post('/merchtComn/merchant/biz/rel/peerMerchantIds/get/by/context/and/peerMerchantType/and/unBlock')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// ========================= 服务网点与零售门店的关系 =======================

exports.getServicerShopRetailerShopRelPageList = function (data, callback) {
    api.post('/merchtComn/servicerShop/RetailerShop/rel/page/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getServicerShopRetailerShopRelAndNotClosedPageList = function (data, callback) {
    api.post('/merchtComn/servicerShop/RetailerShop/rel/not/closed/page/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getServicerShopRetailerShopRelList = function (data, callback) {
    api.post('/merchtComn/servicerShop/RetailerShop/rel/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getServicerShopRetailerShopRelDisableList = function (data, callback) {
    api.post('/merchtComn/servicerShop/RetailerShop/rel/disable/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.doSyncSevicerShopRetailerShopRel = function (data, callback) {
    api.post('/merchtComn/sync/servicerShop/RetailerShop/rel/do')
    .data(data)
    .done(callback)
    .go();
};

exports.deleteSevicerShopRetailerShopRel = function (data, callback) {
    api.post('/merchtComn/servicerShop/RetailerShop/rel/delete/do')
    .params(data)
    .done(callback)
    .go();
};
exports.doDisbaledServcDevcCatRel = function (data, callback) {
    api.post('/merchtComn/servicerShop/RetailerShop/rel/disbaled/do')
    .data(data)
    .done(callback)
    .go();
};

//========================== 商户业务参数 ==========================
exports.getBizParamGroupList = function (data, callback) {// 获取业务参数分组列表
    api.post('/merchtComn/biz/param/group/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.saveMerchantBizParam = function (data, callback) {// 批量保存商户业务参数
    api.post('/merchtComn/merchant/biz/params/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

//交易规则列表
exports.getTradeRuleList = function (params, callback) {// 获取交易规则列表
    api.post('/merchtComn/trade/rule/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 反馈类型列表
exports.getFeedbackTypeList = function (postData, callback) {// 获取反馈类型列表
    api.post('/merchtComn/feedback/type/list/get')
    .data(postData)
    .done(callback)
    .go();
};

// 保存
exports.saveFeedback = function (params, callback) {// 添加问题反馈
    api.post('/merchtComn/feedback/save/do')
    .data(params)
    .done(callback)
    .go();
};

// 反馈分页列表
exports.getFeedbackList = function (params, callback) {// 获取反馈分页列表
    api.post('/merchtComn/feedback/list/get')
    .data(params)
    .done(callback)
    .go();
};

//=================== 历史查询 =======================
let cachedHisQueryConfMap = {}; //查询配置缓存
//根据id获取历史元设查询（结果）配置信息（带客户端缓存）
exports.getHisMetaQueryResultConfById = function (id, callback) {
    if(id == null || id < 0) {
        return null;
    }
    //优先使用缓存
    let cacheKey = (id || null) + '';
    let cachedResult = cachedHisQueryConfMap[cacheKey];
    if(cachedResult == null) {
        api.get('/merchtComn/his/meta/query/result/conf/get/by/id')
        .params({
            id: id || null
        })
        .done(function (result) {
            if(result.success && result.data != null) {
                cachedHisQueryConfMap[cacheKey] = result;
            }
            //
            callback(result);
        })
        .fail(callback)
        .go();
    } else {
        callback(cachedResult);
    }
};

// ================================ 人员资质类型 ================================

exports.getStaffQualiTypes = function (data, callback) {// 【人员资质类型】分页列表
    api.post('/merchtComn/staff/quali/type/list/page/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getStaffQualiTypeLevelListByTypeId = function (params, callback) {// 根据人员资质类型id 获取人员资质类型等级列表
    api.get('/merchtComn/staff/quali/type/level/list/get/by/typeId')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};

// 【人员资质类型】查询
exports.getStaffQualiTypeInfo = function (data, callback) {
    api.post('/merchtComn/staff/quali/type/info/get')
    .data(data)
    .done(callback)
    .go();
};

// 【人员资质类型】分页列表
exports.getStaffQualiTypesByFilter = function (data, callback) {
    api.post('/merchtComn/staff/quali/type/list/page/get')
    .data(data)
    .done(callback)
    .go();
};
// ============================ 专用二维码管理 ============================
exports.getDdctQrcodePageList = function (data, callback) {     // 获取二维码列表
    api.post('/merchtComn/ddct/qrcode/page/list')
    .data(data)
    .done(callback)
    .go();
};
//
exports.saveOrGetDdctQrcode = function (data, callback) {     // 查询且新增二维码
    api.post('/merchtComn/ddct/qrcode/info/get/or/save')
    .data(data)
    .done(callback)
    .go();
};
//
exports.saveDdctQrcode = function (data, callback) {     // 新增二维码列表
    api.post('/merchtComn/ddct/qrcode/save/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.upateDdctQrcodeForInvalid = function (data, callback) {     // 作废二维码列表
    api.post('/merchtComn/ddct/qrcode/update/for/invalid/do')
    .data(data)
    .done(callback)
    .go();
};

// ================== 财务业务类型 ==================

exports.getFinacBizTypePagesList = function (data, callback) {
    api.post('/merchtComn/finac/biz/type/pages/list/get')
    .data(data)
    .done(callback)
    .go();
};

// ================== 商户业务类型 ==================

exports.getMerchtBizTypeInfo = function (params, callback) {
    api.get('/merchtComn/mercht/biz/type/info/get')
    .params(params)
    .done(callback)
    .go();
};
exports.getMerchtBizTypePagesList = function (data, callback) {
    api.post('/merchtComn/mercht/biz/type/pages/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.saveMerchtBizType = function (data, callback) {
    api.post('/merchtComn/mercht/biz/type/save/do')
    .data(data)
    .done(callback)
    .go();
};
exports.updateMerchtBizType = function (data, callback) {
    api.post('/merchtComn/mercht/biz/type/update/do')
    .data(data)
    .done(callback)
    .go();
};
exports.deleteMerchtBizType = function (data, callback) {
    api.post('/merchtComn/mercht/biz/type/delete/do')
    .data(data)
    .done(callback)
    .go();
};
// ================== 实体公司 ==================
exports.getRealCom = function (data, callback) {
    api.get('/merchtComn/real/com/get')
    .params(data)
    .done(callback)
    .go();
};
exports.getRealComByCode = function (data, callback) {
    api.get('/merchtComn/real/com/get/by/code')
    .params(data)
    .done(callback)
    .go();
};
exports.getRealComList = function (data, callback) {
    api.post('/merchtComn/real/com/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getRetailerRealComList = function (data, callback) {
    api.post('/merchtComn/retailer/real/com/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.saveRealCom = function (data, callback) {
    api.post('/merchtComn/real/com/save/do')
    .data(data)
    .done(callback)
    .go();
};
exports.updateRealCom = function (data, callback) {
    api.post('/merchtComn/real/com/update/do')
    .data(data)
    .done(callback)
    .go();
};
exports.deleteRealCom = function (data, callback) {
    api.post('/merchtComn/real/com/delete/do')
    .data(data)
    .done(callback)
    .go();
};
// ================== 实体商户 ==================

exports.getRealMerchantList = function (data, callback) {
    api.post('/merchtComn/real/merchant/page/List/get')
        .data(data)
        .done(callback)
        .go();
};

exports.getRealMerchantInfoByCode = function (data, callback) {
    api.get('/merchtComn/real/merchant/info/get/by/code')
    .params(data)
    .done(callback)
    .go();
};


exports.getRealMerchantInfoById = function (data, callback) {
    api.get('/merchtComn/real/merchant/info/get/by/id')
        .params(data)
        .done(callback)
        .go();
};

// ================== 自定义纳税类型 ==================

// 获取自定义纳税类型分页列表
exports.getCustTaxPayTypeList = function (data, callback) {
    api.post('/merchtComn/cust/tax/pay/type/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 获取自定义纳税类型分页列表
exports.getCustTaxPayTypeByCode = function (params/*realMerchantId：实体商户id（非必传），code：自定义纳税类型编码（必传）*/, callback) {
    api.get('/merchtComn/cust/tax/pay/type/get/by/code')
    .params(params)
    .done(callback)
    .go();
};

// 保存自定义纳税类型
exports.saveCustTaxPayType = function (data, callback) { //
    api.post('/merchtComn/cust/tax/pay/type/save')
    .data(data)
    .done(callback)
    .go();
};
// 获取自定义纳税类型
exports.getCustTaxPayTypeById = function (params, callback) {
    api.get('/merchtComn/cust/tax/pay/type/get/by/id')
    .params(params)
    .done(callback)
    .go();
};
// 删除自定义纳税类型
exports.deleteCustTaxPayType = function (data, callback) {
    api.post('/merchtComn/cust/tax/pay/type/delete')
    .data(data)
    .done(callback)
    .go();
};

// 银行账号列表
exports.getRealComBankAcctList = function (data, callback) { // merchtComn
    api.post('/merchtComn/real/com/bank/acct/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go()
};
// 银行账号查询
exports.getRealComBankAcctById = function (params, callback) { // merchtComn
    api.get('/merchtComn/real/com/bank/acct/get/id')
    .params(params)
    .done(callback)
    .fail(callback)
    .go()
};
// 默认银行账号
exports.getRealComBankAcctDefaulted = function (params, callback) {
    api.post('/merchtComn/real/com/bank/acct/defaulted/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go()
};

/* 银行账号保存 */
exports.saveRealComBankAcct = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/save')
    .data(data)
    .done(callback)
    .fail(callback)
    .go()
};
exports.updateRealComBankAcct = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/update')
        .data(data)
        .done(callback)
        .fail(callback)
        .go()
}
/* 银行账号删除 */
exports.deleteRealComBankAcct = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/delete')
    .data(data)
    .done(callback)
    .fail(callback)
    .go()
};
/* 银行账号锁定 */
exports.updateRealComBankAcctLocked = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/lock/update')
    .data(data)
    .done(callback)
    .fail(callback)
    .go()
};
exports.updateRealComBankAcctUnLocked = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/unlock/update')
        .data(data)
        .done(callback)
        .fail(callback)
        .go()
}
/* 银行账号冻结*/
exports.updateRealComBankAcctFrozen = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/frozen')
    .data(data)
    .done(callback)
    .fail(callback)
    .go()
};
exports.updateRealComBankAcctUnFrozen = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/unfrozen')
        .data(data)
        .done(callback)
        .fail(callback)
        .go()
}
// 设置默认
exports.doDefaultedRealComBankAcct = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/defaulted')
    .data(data)
    .done(callback)
    .fail(callback)
    .go()
};
exports.doEnableRealComBankAcct = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/enable')
        .data(data)
        .done(callback)
        .fail(callback)
        .go()
}
exports.doDisableRealComBankAcct = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/disable')
        .data(data)
        .done(callback)
        .fail(callback)
        .go()
}

exports.getMerchantRealComList = function (data, callback) {
    api.post('/merchtComn/merchant/real/com/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.saveMerchantRealCom = function (data, callback) {
    api.post('/merchtComn/merchant/real/com/save/do')
    .data(data)
    .done(callback)
    .go();
};
exports.deleteMerchantRealCom = function (data, callback) {
    api.post('/merchtComn/merchant/real/com/delete/do')
    .data(data)
    .done(callback)
    .go();
};

// =========================== 公司业务参数 ================================

exports.getComBizParamGroupList = function (data, callback) {
    api.post('/merchtComn/com/biz/param/group/list/get')
    .data(data)
    .done(callback)
    .go()
}

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/merchtComn.js
// module id = 12
// module chunks = 1